/**
 * Versioned, independently replaceable artwork for the ten main-menu portals.
 * Keep this list in era order; menu progression still decides whether an asset
 * is revealed, so locked eras never disclose their destination art.
 */
export const MENU_PORTAL_ART = [
  'era01-primordial.png',
  'era02-cambrian.png',
  'era03-dinosaurs.png',
  'era04-ice-age.png',
  'era05-stone-age.png',
  'era06-empires.png',
  'era07-medieval.png',
  'era08-industrial.png',
  'era09-near-future.png',
  'era10-end-of-time.png',
] as const;

export function portalArtStyle(index: number): string {
  const asset = MENU_PORTAL_ART[index];
  if (!asset) return '';
  return `--portal-image:url('/assets/menu/portals-v2/${asset}');--portal-delay:-${(index * 0.73).toFixed(2)}s`;
}
